import ResizableScene from "./ResizableScene";

export default class ResizableContainer extends Phaser.GameObjects.Container {
	scene: ResizableScene;

	constructor(scene: ResizableScene, x: number, y: number, children?: Phaser.GameObjects.GameObject[]) {
		super(scene, x, y, children);

		this.scene.scale.on(Phaser.Scale.Events.RESIZE, this.resize, this);
	}

	resize(): void {
		return;
	}

	shutdown(): void {
		if (this.scene) this.scene.scale.off(Phaser.Scale.Events.RESIZE, this.resize, this);
	}

	destroy(): void {
		if (this.scene) this.scene.scale.off(Phaser.Scale.Events.RESIZE, this.resize, this);
		super.destroy();
	}
}
